import { EventPlace } from "helpers/analytics";
import { ActionsUnion, createAction } from "store/helper";

export interface ICustomEventProperties {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface IGlobalEventTrackingPayload {
  eventName: string;
  eventProperties?: ICustomEventProperties;
}

export interface IEventTrackingPayload extends IGlobalEventTrackingPayload {
  eventPlace: EventPlace;
  ownPrefix?: string;
}

export enum EventTrackingActionNames {
  TRACK_GLOBAL_EVENT = "FEATURE/EVENT_TRACKING/TRACK_GLOBAL_EVENT",
  TRACK_EVENT = "FEATURE/EVENT_TRACKING/TRACK_EVENT",
}

export const EventTrackingActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  trackGlobalEvent: (eventName: string, eventProperties?: ICustomEventProperties) =>
    createAction(EventTrackingActionNames.TRACK_GLOBAL_EVENT, { eventName, eventProperties }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  trackEvent: (
    eventName: string,
    eventPlace: EventPlace,
    eventProperties?: ICustomEventProperties,
    ownPrefix?: string
  ) => createAction(EventTrackingActionNames.TRACK_EVENT, { eventName, eventPlace, eventProperties, ownPrefix }),
};

export type EventTrackingAction = ActionsUnion<typeof EventTrackingActions>;
